import React, { useEffect } from 'react'
import { isNil } from 'lodash'
import { MessageViewer } from '@awell/ui-kit/components/MessageViewer'
import { Spinner } from '@awell/ui-kit/components/Spinner'
import { Message } from '../../../../hooks/useMessageActivity/types'
import { Activity } from '../../types'

interface Props {
  message?: Message
  activity: Activity
  loading: boolean
  onRead?: () => Promise<void>
}

export const MessageTab: React.FC<Props> = ({ message, loading, onRead }) => {
  useEffect(() => {
    if (!loading && !isNil(onRead)) {
      void onRead()
    }
  }, [loading, onRead])

  if (loading || !message) {
    return (
      <div className="flex justify-center">
        <Spinner />
      </div>
    )
  }

  return (
    <div className="mx-4">
      <MessageViewer body={message.body ?? ''} attachments={message.attachments ?? []} />
    </div>
  )
}
